module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_vm._v("List of Plates")])]), _c('a', {
    attrs: {
      "id": "h3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Colour")])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/15_chapter041#cmap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2pm The Initial French Advance.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter042#cmap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Situation at 2.45pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter043#cmap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Allied Crisis 3–3.30pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter044#cmap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Main French Attack (1) about 4pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter045#cmap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Main French Attack (2) about 4.30pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter046#cmap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The High Water Mark about 5.00pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter047#cmap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kellerman’s Charge about 7.00pm.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter048#cmap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D’Erlon’s March.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Black & White")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter111#plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emperor Napoleon.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter112#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshal Ney.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter113#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marshal Soult.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter114#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général")]), _vm._v(" Jean-Baptiste Drouet, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Comte")]), _vm._v(" d’Erlon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter115#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général")]), _vm._v(" Honoré Charles Reille.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter116#plate6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général Comte")]), _vm._v(" Gilbert Désiré Joseph Bachelu.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter117#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général")]), _vm._v(" Prince Jérôme Bonaparte.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter118#plate8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général Comte")]), _vm._v(" Maximilien Sebastien Foy.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter119#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieutenant Général")]), _vm._v(" François Etienne Kellerman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Comte de")]), _vm._v(" Valmy.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter1110#plate10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quatre Bras farmhouse.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter1111#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Namur road looking south-east from Quatre Bras.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter1112#plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A view from the Quatre Bras crossroads.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter1113#plate13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The farm of La Bergerie.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter1114#plate14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gémioncourt farm from the south.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter1115#plate15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The entrance to the Gémioncourt farm looking east from the main road.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter1116#plate16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The memorial to the Duke of Brunswick.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter1117#plate17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 42nd are caught by French lancers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter1118#plate18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The colour of the 2/69th is captured.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2f1b94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_plates.vue
// module id = 72
// module chunks = 0